import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { BrowserService } from '../browser.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private counter: number = 0;
  constructor(
    private _authService: AuthService,
    private browserService: BrowserService
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const originalRequest = request;
    return next.handle(originalRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error && error.status === 401 && this.counter < 2) {
          this.counter++;
          //Token expired? Attempt to refresh the token
          return this._authService.refreshToken().pipe(
            switchMap((result) => {
              this.browserService.localStorageSetItem('RefreshToken', result.refreshtoken);
              // Retry the original request with the new token
              return next.handle(originalRequest).pipe(
                catchError((error: HttpErrorResponse) => {
                  if (error && (error.status === 401 || error.status === 403)) {
                    this._authService.logout(true);
                  }
                  return throwError(
                    () =>
                      new Error(
                        'sending the original request from interceptor failed. Server error is: ' +
                          error.message,
                      ),
                  );
                }),
              );
            }),
          );
        } else {
          this.counter = 0;
          return throwError(() => error);
        }
      }),
    );
  }
}
